export default {
  methods: {
    $_GoTo_PATH(path) {
      this.$router.push({ path: path })
    },
    $_GoTo_NAME(name) {
      this.$router.push({ name: name })
    }
  }
}
